export default (arg: string) => arg;
